<template>
    <div class="paper-card flex flex-col gap-4 rounded border border-solid border-grey-40 bg-white px-6 py-4">

        <div class="flex items-center gap-4">

            <span class="shrink-0 text-xl font-semibold text-black">
                {{title}}
            </span>

            <div class="th-tooltip" :data-tip="t('enterpriseDomainTip')">
                <PtIcon icon="SolidInfo" class="fill-grey-55 text-2xl" />
            </div>

            <i class="grow"></i>

            <button @click="downloadChartAsImage" :disabled="disableUI" class="th-btn th-btn-plain shrink-0">
                <PtIcon class="th-btn-icon fill-grey-450 text-2xl" icon="SolidExport" />
                <span>
                    {{t('download')}}
                </span>
            </button>
        </div>

        <BIChart ref="WordCloudTrendChart"
                 :chartKey="chartKey"
                 :isLoading="isFetchLoading"
                 :configTaskFunc="chartConfig"
                 :dataTaskFunc="getWordCloudChartData"
                 @click="handleDrillDown"
                 class="relative h-[480px] w-full" />
    </div>
</template>

<script setup lang="ts">
import BIChart from '@/components/BIChart.vue';
import { useWordCloud } from '@/composables/use-word-cloud';
import { ref } from 'vue';
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/export.svg';
import { useI18n } from 'vue-i18n';
const { t } = useI18n()

const WordCloudTrendChart = ref<{
    generateChartImage: () => Promise<string>,
    drawChart: () => void,
    isChartLoaded: () => boolean
    isEmptyChart: boolean
}>();

const {
    title,
    disableUI,
    isFetchLoading,
    chartKey,
    chartConfig,
    getWordCloudChartData,
    downloadChartAsImage,
    handleDrillDown,
} = useWordCloud(WordCloudTrendChart);

</script>
